import React, { useContext, useEffect, useState } from "react";
import { livetrackingcontext } from "../../../../../context/LiveTrackingContext";
import trans from "../../../../../utils";
import { filtrationcontext } from "../../../../../context/Filtercontext";
import { useSelector } from "react-redux";
import Loader from "../../../../Helpers/Loader/Loader";
import { useGetAllGroupsQuery } from "../../../../../Redux/service/Groups/Groups";
import TrackedTableRow from "./TrackedTableRow";
import { useGetSpecificUserQuery } from "../../../../../Redux/service/Users/Users";

export default function TrackedTableBody() {
	const [openDropdowns, setOpenDropdowns] = useState([]);
	const [shownData, setShownData] = useState([]);
	const {
		filter,
		isFilterTriggered,
		setIsFilterTriggered,
		ObjectsearchQuery,
		parentCheck,
		childCheck,
	} = useContext(filtrationcontext);
	let { trackingType, imei, setImei } = useContext(livetrackingcontext);
	const inf = useSelector((state) => state.users.user);

	const { data: UserInf, isLoading: userLoading } = useGetSpecificUserQuery(
		inf?.id,
	);
	const { data: allUsers, isLoading: allUsersLoading } = useGetAllGroupsQuery();
	const toggleDropdown = (userId) => {
		setOpenDropdowns((prevOpenDropdowns) =>
			prevOpenDropdowns.includes(userId)
				? prevOpenDropdowns.filter((id) => id !== userId)
				: [...prevOpenDropdowns, userId],
		);
	};
	useEffect(() => {
		if (!filter && UserInf) {
			setShownData([UserInf]);
		}
	}, [UserInf, filter, allUsers]);

	useEffect(() => {
		if (!allUsers || !isFilterTriggered) return;
		let filteredData = [];
		if (filter) {
			filteredData = allUsers?.filter((user) => {
				const matchesFilter = parentCheck.includes(user.id);
				return matchesFilter;
			});
		}
		setShownData(filteredData);
		setIsFilterTriggered(false);
	}, [
		UserInf,
		childCheck,
		allUsers,
		filter,
		parentCheck,
		ObjectsearchQuery,
		isFilterTriggered,
	]);

	if (userLoading || allUsersLoading) return <Loader />;
	if (!UserInf)
		return (
			<div className="my-5 p-5">
				<div className="text-center text-success fs-16 fw-700">
					{trans("No data shown")}
				</div>
			</div>
		);
	console.log("Shown Data", shownData);
	console.log("UserInf", UserInf);
	return (
		<>
			{shownData.map((user) => (
				<>
					<div
						key={user?.id}
						className="object-body-title"
						role="button"
						onClick={() => toggleDropdown(user?.id)}
					>
						<div className="d-flex">
							<div
								className="fs-14 fw-400 neutral-500 object-table-element"
								role="button"
							>
								<div className={user ? "fw-900" : ""}>
									{filter
										? user?.name
										: trackingType === "vehicle"
											? trans("Ungrouped Vehicles")
											: trans("Ungrouped Devices")}
								</div>
							</div>
						</div>
						<div className={!filter && "d-none"}>
							<img
								src={
									openDropdowns.includes(user?.id)
										? `${process.env.PUBLIC_URL}/assets/Uparrow.svg`
										: `${process.env.PUBLIC_URL}/assets/Downarrow.svg`
								}
								alt="arrow"
							/>
						</div>
					</div>
					{<TrackedTableRow userid={user?.id} imei={imei} setImei={setImei} />}
				</>
			))}
		</>
	);
}
